import { Modal, Button, Row, Col } from "react-bootstrap";
import { modal } from "@/utils/constant";
import { buildEncryptedUrl } from "@/utils/urlParams";
import { getDepartmentSlug } from "@/utils/department";

function JoinModal({
  hide,
  show,
  facilitatorData,
  facilitatorId,
  teamId,
  teamData,
}) {
  // const department_name = [1, 5].includes(facilitatorData?.role_id?.id)
  //   ? "emergencydm"
  //   : [2, 6].includes(facilitatorData?.role_id?.id)
  //   ? "surgerydm"
  //   : [3, 7].includes(facilitatorData?.role_id?.id)
  //   ? "criticalcaredm"
  //   : "stepdowndm";

  // const departmentLink =
  //   teamData.current_status >= 3 || teamData.current_round > 0
  //     ? department_name
  //     : "join";

  return (
    <>
      <Modal show={show} onHide={hide} size="lg" centered>
        <Modal.Header className="bg-secondary" closeButton>
          <Modal.Title> {modal?.joinModalTitalText}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-10 px-lg-14">
          <p>{modal?.joinModalBodyText}</p>
          <Row className="mt-8">
            <Col>
              <Button
                variant="secondary"
                onClick={hide}
                href={buildEncryptedUrl(
                  `${process.env.REACT_APP_GAME_URL}/${getDepartmentSlug(facilitatorData?.role_id?.id)}`,
                  {
                    participant_id: facilitatorData.participant_id?.id,
                    team_id: teamId,
                    session_id: facilitatorData.session_id,
                    join_as: facilitatorId,
                    department_id: facilitatorData?.role_id?.id,
                  }
                )}
                className="font-semibold w-full text-no-decoration"
                target="_blank"
                rel="noreferrer"
              >
                {modal?.joinModalButtonText}
              </Button>
            </Col>
            <Col>
              <Button
                variant="outline-primary"
                className="font-semibold w-full"
                onClick={hide}
              >
                {modal?.cancle}
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default JoinModal;
